/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Reset_ButtonInputs */

const en_video_filters_reset_button = /** @type {(inputs: Video_Filters_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset All`)
};

const fr_video_filters_reset_button = /** @type {(inputs: Video_Filters_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout reinitialiser`)
};

const de_video_filters_reset_button = /** @type {(inputs: Video_Filters_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles zurücksetzen`)
};

const it_video_filters_reset_button = /** @type {(inputs: Video_Filters_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reimposta tutto`)
};

const ru_video_filters_reset_button = /** @type {(inputs: Video_Filters_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить все`)
};

const es_video_filters_reset_button = /** @type {(inputs: Video_Filters_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer todo`)
};

const zh_cn2_video_filters_reset_button = /** @type {(inputs: Video_Filters_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部重置`)
};

const ja_video_filters_reset_button = /** @type {(inputs: Video_Filters_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてリセット`)
};

const hi_video_filters_reset_button = /** @type {(inputs: Video_Filters_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी को पुनः तैयार करना`)
};

const pt_pt2_video_filters_reset_button = /** @type {(inputs: Video_Filters_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redefinir tudo`)
};

/**
* | output |
* | --- |
* | "Reset All" |
*
* @param {Video_Filters_Reset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_reset_button = /** @type {((inputs?: Video_Filters_Reset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Reset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_filters_reset_button(inputs)
	if (locale === "de") return de_video_filters_reset_button(inputs)
	if (locale === "it") return it_video_filters_reset_button(inputs)
	if (locale === "ru") return ru_video_filters_reset_button(inputs)
	if (locale === "es") return es_video_filters_reset_button(inputs)
	if (locale === "zh-CN") return zh_cn2_video_filters_reset_button(inputs)
	if (locale === "ja") return ja_video_filters_reset_button(inputs)
	if (locale === "hi") return hi_video_filters_reset_button(inputs)
	if (locale === "pt-PT") return pt_pt2_video_filters_reset_button(inputs)
	return en_video_filters_reset_button(inputs)
});